var React = require('react');
var createReactClass = require('create-react-class');
var Helmet = require('react-helmet');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var PropTypes = require('prop-types');
var Callout = require('../../components/callout.jsx');
var LoginBox = require('../../components/loginBox.jsx');

var Login = createReactClass({
	mixins: [PureRenderMixin],

	componentDidMount: function(){
		this.unlisten = this.context.router.listen(function(location){
			if(location.pathname !== this.props.location.pathname && location.pathname !== '/register'){
				this.props.clearLoginRedirectUrl();
			}
		}.bind(this));
	},

	componentWillUnmount: function(){
		this.props.clearLoginError();
		this.unlisten();
	},

    render: function(){
        var loginError = this.props.auth.error;
        return (
			<div className="content">
              <Helmet
                  title="Login"
                  meta={[{
                      name: 'description',
                      content: 'Log in to your MyGiHealth account'
                  }]}
              />
	            <div className="row">
                    {Object.keys(loginError).length !== 0 &&
    		            <Callout type="alert" message={loginError.error_description ? loginError.error_description : loginError.toString()} handleClose={this.props.clearLoginError} />
    		        }
	                <div className="large-6 small-12 column show-for-large">
						<div className="hero-text-block">
							<h1>Welcome back,<br /> <strong>How are you feeling today?</strong></h1>
							<p>Our doctor-designed tools empower you to learn about, assess and track their symptoms, while connecting directly with top-notch Gi physicians</p>
						</div>
	                </div>
	                <div className="large-5 small-12 column end">
	                    <LoginBox
                            login={this.props.login}
                            loginRedirectUrl={this.props.auth.loginRedirectUrl}
                            authFacebook={this.props.authFacebook}
                            source="Login"
                            recordLoginClick={this.props.recordLoginClick} />
						<p className="hide-for-large">
							<a className="download-app" href="http://get.mygihealth.io/downloadtheapp">
								<img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/app-store-badge.png" alt="Download on the App Store" id="app-store-badge" />
							</a>
						</p>
	                </div>
	            </div>
			</div>
        )
    }
});

Login.contextTypes = {
  	router: PropTypes.object.isRequired
};

module.exports = Login;



// WEBPACK FOOTER //
// ./src/common/routes/login/components/login.jsx